"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var titles = {
  artworkTitle: "Home",
  descriptionTitle: "Concept"
};
var _default = titles;
exports["default"] = _default;